export default __webpack_public_path__ + "static/media/arik-einstein_ahava-memabat-rishon.68330ae7.mp3";